import { UpdateWardComponent } from './update-ward/update-ward.component';
import { CreateWardComponent } from './create-ward/create-ward.component';
import { WardsComponent } from './wards.component';
import { MainLayoutComponent } from '@components/main-layout/main-layout.component';
import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { NgxPermissionsGuard } from 'ngx-permissions';

export const wardsRoutes: Routes = [
    {
        path: 'admin/wards',
        component: MainLayoutComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'ADMIN_PANEL',
                redirectTo: '/'
            }
        },
        children: [
            { path: '', component: WardsComponent },
            { path: 'create', component: CreateWardComponent },
            { path: ':id/update', component: UpdateWardComponent }
        ]
    }
];
